module.exports = __webpack_public_path__ + "img/33.a3d33f97.png";